const qa = document.querySelectorAll(".c-faq__item-question");

function acToggle() {
  const content = this.nextElementSibling; // 回答部分（次の要素）を取得
  const parentItem = this.closest(".c-faq__item"); // 親要素を取得

  content.classList.toggle("is-open");
  this.classList.toggle("is-open");
  parentItem.classList.toggle("is-open"); // 親要素にもクラスを追加/削除
}

qa.forEach((item) => {
  item.addEventListener("click", acToggle);
});
